import React from 'react';
import s from './InterSectionBorder.scss';

function InterSectionBorder() {
  //const { data } = props;
  return <span className={s.doubleboder} />;
}

export default InterSectionBorder;
